export enum EmailApiRoutes {
  EmailQuoteEstimate = '/emails/quotes/:id/send',
  PayByBank = '/emails/pay-by-bank/:id/send',
  ResendLocEmail = '/emails/loc/:id/send',
  ResendEasyPayPortalInvite = '/emails/eep-portal-invite/:id/send',
  SendTransferOfOwnershipForm = '/emails/transfer-of-ownership/:id/send',
  ResendCancelConfirmationEmail = '/emails/cancel-confirmation/:id/send',
  ResendNonPayConfirmationEmail = '/emails/non-pay-confirmation/:id/send',
  SendInexactMileageEmail = '/emails/mileage-verification/:id/send',
}
